import { useHistory } from 'react-router-dom'
import OrganizationalMenu from '../../../../../components/stories/organisms/top-navigation/components/organizational-menu'
import { useOrganizationalAccess } from '../../../../../hooks/use-organizational-access'
import { useAccessToken } from '../../../../../zustand/authentication/use-auth-store'

const Settings = () => {
  const accessToken = useAccessToken()
  const { push } = useHistory()
  const {
    isResolved,
    canSeeUserManagement,
    canSeeReportTemplates,
    canViewControlPanel
  } = useOrganizationalAccess()

  if (!isResolved) {
    return null
  }

  const handleNavigateToManageUsers = () => {
    push('/userManagement')
  }

  const handleNavigateToReportTemplates = () => {
    push('/reports?view=templates')
  }

  const handleNavigateToControlPanel = () => {
    const controlPanelUrl = `${import.meta.env.VITE_CONTROL_PANEL_URL}/?token=${accessToken}`
    window.open(controlPanelUrl, '_blank', 'noopener,noreferrer')
  }

  if (!canSeeUserManagement && !canSeeReportTemplates && !canViewControlPanel) {
    return null
  }

  return (
    <OrganizationalMenu
      key="settings"
      onClickManageUsers={handleNavigateToManageUsers}
      onClickReportTemplates={handleNavigateToReportTemplates}
      onClickControlPanel={handleNavigateToControlPanel}
      canSeeUserManagement={canSeeUserManagement}
      canSeeReportTemplates={canSeeReportTemplates}
      canViewControlPanel={canViewControlPanel}
    />
  )
}

export default Settings
